export default "__VITE_ASSET__CvfmUxPO__"